import {lazy} from './lazy.js';
import {doc} from '../docs.js';
import { float } from './utils.js';
import {extractCode} from './extract.js';

doc(
    "gl.texture2D",
    {
        "texture": "",
        "textureCoords": ""
    },
    "Calls texture2D on texture and texture coords",
    () => 1,
    {
        isHot: true,
        inlets: 2
    });
export const gl_texture2D = (object, texCoords) => {
    object.needsHotReload = true;

    return lazy((msg) => {
        let codes = extractCode(msg, texCoords);
        object.flash();
        return `(texture2D((${float(codes[0])}), (${float(codes[1])})))`;
    }, texCoords);
};
